export default __webpack_public_path__ + "static/media/finish-wizard-image.0bb1fc53.svg";